import React from 'react';
import { symbol as Symbol, type SymbolProps } from '@wix/santa-editor-symbols';

import { compIcon } from '#packages/util';

interface SymbolWrapperProps extends React.SVGAttributes<SVGElement> {
  name: string;
  size?: string | number;
}

export const SymbolWrapper: React.FC<SymbolProps | SymbolWrapperProps> = ({
  name,
  ...props
}) => {
  const WixUiIcon = compIcon.getWBUIcon(name);
  return WixUiIcon ? (
    // @ts-expect-error
    <WixUiIcon {...props} />
  ) : (
    <Symbol name={name} {...props} />
  );
};
